import { useTranslation } from 'react-i18next';
import { Link, NavLink, useNavigate } from 'react-router';
import { useGetAliveQuery } from '../alive/aliveEndpoints';
import { useAuthServices } from '../auth/authServices';
import { useGetMeQuery } from '../auth/authEndpoints';

/**
 * The signed-in admin's navbar (QZ-D18, QZ-D47, QZ-D58): the app name with its environment
 * badge, the page links, their email and sign-out. The environment comes from `/alive`, since
 * `config.json` carries none (QZ-D10); until it answers there is no badge.
 */
export const Navbar = () => {
  const { t } = useTranslation();
  const { session } = useAuthServices();
  const navigate = useNavigate();
  const { data } = useGetMeQuery();
  const { data: alive } = useGetAliveQuery();

  const handleSignOut = async () => {
    await session.signOut();
    navigate('/signin', { replace: true });
  };

  return (
    <nav className="qz-navbar">
      <div className="qz-container qz-navbar-inner">
        <Link className="qz-brand" to="/">
          <span className="qz-brand-mark" aria-hidden="true">
            ?
          </span>
          {t('nav.appName')}
        </Link>
        {alive && <span className="qz-env">{alive.envType}</span>}
        <div className="qz-nav-links">
          <NavLink to="/tasks">{t('nav.tasks')}</NavLink>
          <NavLink to="/jobs">{t('nav.jobs')}</NavLink>
          <NavLink to="/tags">{t('nav.tags')}</NavLink>
          <NavLink to="/sources">{t('nav.sources')}</NavLink>
        </div>
        <div className="qz-nav-user">
          {data?.email && <span>{data.email}</span>}
          <button
            type="button"
            className="btn btn-sm btn-outline-secondary qz-btn-nav"
            onClick={handleSignOut}
          >
            {t('nav.signOut')}
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
